import * as React from 'react'
import { cn } from '@/lib/utils'

export type ThermometerProps = {
  value: number // 0..100
  className?: string
  showLabel?: boolean
}

// Barra com gradiente: vermelho (esquerda) -> verde (centro) -> azul-escuro (direita)
// Mantém a mesma altura/raio da barra de progresso padrão do projeto.
export function Thermometer({ value, className, showLabel = false }: ThermometerProps) {
  const v = Math.max(0, Math.min(100, Number(value || 0)))
  const left = `${v}%`
  return (
    <div
      className={cn('relative h-2 w-full rounded', className)}
      style={{
        background:
          'linear-gradient(90deg, #CC2B2B 0%, #CC2B2B 10%, #21C15E 50%, #0B1E5E 90%, #0B1E5E 100%)',
      }}
      aria-label={`Termômetro ${v}%`}
    >
      {/* Ponteiro: usa left:% relativo ao container e compensa metade da largura */}
      <div
        className="pointer-events-none absolute top-1/2"
        style={{ left, transform: 'translate(-50%, -50%)' }}
      >
        <div className="h-3 w-[2px] rounded-full bg-white/90 shadow" />
      </div>
      {showLabel && (
        <div
          className="absolute -bottom-4 select-none text-[10px] text-foreground/70"
          style={{ left, transform: 'translateX(-50%)' }}
        >
          {v}%
        </div>
      )}
    </div>
  )
}
